import styled from 'styled-components';
import Icon from '@nubank/nuds-web/components/Icon/Icon';

export const StyledIcon = styled(Icon)`
  min-width: 1rem;
  min-height: 1rem;
`;

StyledIcon.displayName = 'StyledIcon';
